import * as React from "react";
import { cn } from "@/lib/utils";

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "default" | "sm" | "lg" | "xl";
}

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = "default", ...props }, ref) => {
    const sizeClass = {
      sm: "h-4 w-4 border-2",
      default: "h-8 w-8 border-3",
      lg: "h-12 w-12 border-4",
      xl: "h-20 w-20 border-[6px]",
    };

    return (
      <div
        ref={ref}
        className={cn(
          "animate-spin rounded-full border-solid border-b-transparent",
          sizeClass[size],
          "border-primary",
          className
        )}
        {...props}
      />
    );
  }
);

Spinner.displayName = "Spinner"; 